export const TOKEN_COOKIE_KEY = '_skuby-web-token'
